import {Component, Input, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../store';
import {ActivatedRoute} from "@angular/router";
import {Workspace} from "../../../../../../user-managment/workspace";
import {clientRoles} from "../../../../../../user/user-roles-actions";

@Component({
    selector: 'db-cdn-settings',
    templateUrl: './cdn-settings.component.html',
    styleUrls: ['./cdn-settings.component.scss'],
    standalone: false
})
export class CdnSettingsComponent implements OnInit {
  @Input() isNameServer: boolean;
  @Input() hasDcvRecord: boolean;
  @Input() currentWorkspace: Workspace;

  public websiteId: number;
  public isMember: boolean;

  constructor(
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.isMember = [clientRoles.SITE_DEV, clientRoles.COMPANY_DEV].includes(this.currentWorkspace?.roleId);

    this.websiteId = +this._route.snapshot.parent.parent.params['id'];
  }

}
